var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBeautyStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 21.0156C22 14.9405 26.9248 10.0156 33 10.0156C39.0752 10.0156 44 14.9405 44 21.0156C44 27.0908 39.0752 32.0156 33 32.0156C26.9248 32.0156 22 27.0908 22 21.0156Z",
    stroke: "#15D4B6",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 40.0156V32.0156M33 40.0156H39M33 40.0156H27",
    stroke: "#15D4B6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22.0156V20.5156C3.17158 20.5156 2.5 21.1872 2.5 22.0156H4ZM16 22.0156H17.5C17.5 21.1872 16.8284 20.5156 16 20.5156V22.0156ZM4 23.5156H16V20.5156H4V23.5156ZM14.5 22.0156V34.0156H17.5V22.0156H14.5ZM5.5 34.0156V22.0156H2.5V34.0156H5.5ZM10 38.5156C7.51472 38.5156 5.5 36.5008 5.5 34.0156H2.5C2.5 38.1578 5.85786 41.5156 10 41.5156V38.5156ZM14.5 34.0156C14.5 36.5008 12.4853 38.5156 10 38.5156V41.5156C14.1421 41.5156 17.5 38.1578 17.5 34.0156H14.5Z",
    fill: "#15D4B6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22.0156H14V11.2516C14 9.76485 12.4354 8.79785 11.1056 9.46275L7.10558 11.4627C6.428 11.8015 6 12.4941 6 13.2516V22.0156Z",
    stroke: "#15D4B6",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBeautyStore);
export default __webpack_public_path__ + "static/media/iconBeautyStore.2a306fe57518d1ddc7c9b5e0f9cfac0a.svg";
export { ForwardRef as ReactComponent };